import Paragraph from '.';

/** @type {UICore.ComponentMeta} */
const ParagraphComponentMeta = {
  id: 'w-paragraph',
  name: '行',
  category: '布局',
  icon: 'https://vfiles.gtimg.cn/wuji_dashboard/xy/rainbow/icon-paragraph_1636961373398.png',
  component: Paragraph,
  slots: [{
    id: 'default',
    containerRef: 'container'
    // 由于无极里，大家已经习惯在行内放block，所以这个判断没意义了。
    // 后续严格模式可能会用上，先注释掉
    // beforeDrop: ({ compMeta }) => compMeta && (compMeta.display === 'inline' || compMeta.display === 'universal'),
  }],
  events: [{
    id: 'click',
    name: '点击行'
  }, {
    id: 'mouseenter',
    name: '鼠标进入行'
  }, {
    id: 'mouseleave',
    name: '鼠标离开行'
  }],
  propsSchema: {
    type: 'object',
    fields: [{
      id: 'align',
      type: 'string',
      title: '水平对齐',
      enum: [{
        value: 'left',
        label: '左对齐'
      }, {
        value: 'center',
        label: '居中'
      }, {
        value: 'right',
        label: '右对齐'
      }, {
        value: 'space-evenly',
        label: '均匀分布'
      }]
    }, {
      id: 'valign',
      type: 'string',
      title: '垂直对齐',
      default: 'center',
      enum: [{
        value: 'top',
        label: '上对齐'
      }, {
        value: 'center',
        label: '居中'
      }, {
        value: 'bottom',
        label: '下对齐'
      }]
    }, {
      id: 'gap',
      type: 'string',
      title: '元素间距',
      description: '示例： 8px',
      default: '',
      condition: 'props.align !== "space-evenly"'
    }, {
      id: 'noWrap',
      type: 'boolean',
      title: '不自动换行'
    }, {
      id: 'css',
      type: 'string',
      title: '自定义样式',
      default: '',
      condition: '!!props.css',
      // 历史原因。。以后不提供了
      ui: {
        settings: {
          multipleLine: true
        }
      }
    }, {
      id: 'lazyRender',
      title: '懒加载',
      description: '组件可见后才渲染组件插槽内部的元素',
      type: 'boolean',
      default: false
    }]
  },
  getActions({
    instance,
    layout,
    updateCompProp,
    replaceCompWith
  }) {
    /** @type {UICore.ComponentDesignAction} */
    const ans = [{
      title: '拆除',
      icon: 'fa fa-scissors',
      desc: '拆除“行”容器，但是保留里面的内容',
      execute: () => replaceCompWith(...(layout.children || []))
    }];
    const currentAlign = instance.align;
    const items = [{
      title: '左对齐',
      icon: 'fa fa-align-left',
      value: 'left'
    }, {
      title: '居中',
      icon: 'fa fa-align-center',
      value: 'center'
    }, {
      title: '右对齐',
      icon: 'fa fa-align-right',
      value: 'right'
    }];
    ans.push({
      title: '|',
      place: 'actionBar'
    });
    ans.push(...items.map(x => ({
      title: '',
      desc: x.title,
      icon: x.icon,
      place: ['actionBar', 'contextMenu'],
      highlighted: currentAlign === x.value,
      execute: () => updateCompProp('align', x.value)
    })));
    return ans;
  },
  placeCompInside() {
    return 'default';
  }
};
export default ParagraphComponentMeta;